
export class Destinazione {
    citofono: string;
    indirizzo: string;
    zip: string;
    citta: string;
    provincia: string;
    iSOStato: string;
  }
  